// extracted by mini-css-extract-plugin
export default {"gamecard":"game-card_gamecard__8GevX"};